<template>
    <form @submit.prevent="submitForm">

                <field-markdown required v-model="form.laboratory"   label="آزمایشگاه تجهیزات" placeholder=""/>


        <alert :success="success" :danger="danger"></alert>
        <button-submit title="ثبت"/>
    </form>
</template>


<script>
    import ButtonSubmit from "../../ButtonSubmit";
    import Alert from "../../Alert";

    import mixinForm from "../../../mixins/mixinForm";
    import FieldTextarea from "../../fields/FieldTextarea";
    import FieldMarkdown from "../../fields/FieldMarkdown";

    export default {
        mixins: [mixinForm],
        components: {
            FieldMarkdown,
            FieldTextarea,
            Alert,
            ButtonSubmit,
        },
        name: "FormLaboratory",
        data() {
            return {
                action: "/settings",
            }
        },
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/forms/setting/FormLaboratory.vue